<div class="row">
  <div class="col-12 col-md-6">
    <div class="dx-field mb-3">
      <dx-check-box
        text="Monthly Executive Summary"
        [(value)]="emailList.monthly_executive"
      ></dx-check-box>
    </div>

    <div class="dx-field mb-3">
      <dx-check-box
        text="Weekly Marketplace Changes (Fridays)"
        [(value)]="emailList.weekly_changes"
      ></dx-check-box>
    </div>
  </div>

  <div class="col-12 col-md-6">
    <div class="dx-field mb-3">
      <dx-check-box
        text="Favorite Items Alert"
        [(value)]="emailList.fav_listings"
      ></dx-check-box>
    </div>

    <div class="dx-field mb-3">
      <dx-check-box
        text="Weekly News / Trending Products (Tuesdays)"
        [(value)]="emailList.trending_products"
      ></dx-check-box>
    </div>
  </div>
</div>

<div class="subscription-footer text-right mt-3">
  <dx-button
    text="Update"
    type="success"
    [width]="140"
    height="44px"
    (onClick)="onSubmit()"
  ></dx-button>
</div>
